import { Head, Link, useForm } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import type { FormEvent } from "react"

export default function Register() {
  const { data, setData, post, processing, errors } = useForm({
    email_address: "",
    password: "",
    password_confirmation: "",
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post("/registration")
  }

  return (
    <>
      <Head title="Create Account" />
      <div className="flex min-h-svh items-center justify-center bg-background p-4">
        <Card className="w-full max-w-sm">
          <CardHeader className="text-center">
            <CardTitle className="text-xl">Create a Feedwatch account</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email_address">Email</Label>
                <Input
                  id="email_address"
                  type="email"
                  value={data.email_address}
                  onChange={(e) => setData("email_address", e.target.value)}
                  placeholder="you@example.com"
                  autoComplete="email"
                  required
                />
                {errors.email_address && (
                  <p className="text-destructive text-sm">{errors.email_address}</p>
                )}
              </div>

              <div className="space-y-2">
                <Label htmlFor="password">Password</Label>
                <Input
                  id="password"
                  type="password"
                  value={data.password}
                  onChange={(e) => setData("password", e.target.value)}
                  autoComplete="new-password"
                  required
                />
                {errors.password && (
                  <p className="text-destructive text-sm">{errors.password}</p>
                )}
              </div>

              <div className="space-y-2">
                <Label htmlFor="password_confirmation">Confirm Password</Label>
                <Input
                  id="password_confirmation"
                  type="password"
                  value={data.password_confirmation}
                  onChange={(e) => setData("password_confirmation", e.target.value)}
                  autoComplete="new-password"
                  required
                />
                {errors.password_confirmation && (
                  <p className="text-destructive text-sm">{errors.password_confirmation}</p>
                )}
              </div>

              <Button type="submit" className="w-full" disabled={processing}>
                {processing ? "Creating account..." : "Create account"}
              </Button>

              <p className="text-center text-sm text-muted-foreground">
                Already have an account?{" "}
                <Link href="/session/new" className="text-primary underline underline-offset-4 hover:text-primary/80">
                  Sign in
                </Link>
              </p>
            </form>
          </CardContent>
        </Card>
      </div>
    </>
  )
}

Register.layout = (page: React.ReactNode) => page
